// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","276":"GuestLazyComponent"}[chunkId] + "." + {"46":"6c97d4264e51222b2273","276":"5942e5633363cfa08307"}[chunkId] + ".js";
};